import { Component } from 'react'
import { connect } from 'react-redux'
import Portal from '../Portal'
import ProgrammableLink from '../ProgrammableLink'
import { H4 } from '../../cdl-react-components/components'
import { getCookie, setCookie } from '../../cdl-react-components/utilities'
import './styles.scss'

const COOKIE_NAME = "DigestClientParty2024"

class RSVPPopup extends Component {
    state = { 
        shown: false,
        closed: false
    }

    handleClose = () => this.setState({ shown: false, closed: true })
    handleClick = () => new Promise(res => {
        this.handleClose()
        setCookie(COOKIE_NAME, true)
        res()
    })

    render() {
        return this.state.shown ? (
            <Portal id="rsvp-popup">
                <div id="rsvp-popup__content">
                    <span id="rsvp-popup__close" 
                        title="close"
                        onClick={this.handleClose}>X</span>
                    <H4>You're invited to CDL's <b>2024 Holiday Appreciation Party</b>! Join us for canapés, cocktails, beer and mocktails on <b>Thursday, December 5<sup>th</sup></b> between 4:00 and 7:00 pm.</H4>
                    <ProgrammableLink 
                        className="btn btn--raised"
                        target="_blank"
                        rel="noreferrer"
                        href={`https://hubs.ly/Q02Xs1dK0`}
                        onBeforeRedirect={this.handleClick}>RSVP</ProgrammableLink>
                </div>
            </Portal>
        ) : null
    }

    componentDidUpdate() {
        if (!this.state.closed &&
            !this.state.shown &&
            (!getCookie(COOKIE_NAME) && !!this.props.user) &&
            Date.now() <= new Date('2024-11-23')
        ) {
            this.setState({ shown: true })
        }
    }
}

const mapStateToProps = ({data}) => ({ user: data.user })
export default connect(mapStateToProps)(RSVPPopup)